<script>
import Notification from '../../reUse/Notification.vue';
export default {
  components: {
    Notification,
  },
  data() {
    return {
      text: '',
      types: '',
      ShowNoti: false,
      glava: [{
        "zapis": ""
      }],
      indexBrisanja: '',
      logotip: '',
      isSubmitting: false,
    }
  },
  mounted() {
    this.GetData();
  },
  methods: {
    GetData() {
      axios.get('./api/nastavitve/splosno/izpiski/', {withCredentials: true}).then((response) => {
        this.glava = response.data.zapisi;
        this.logotip = response.data.logo;
      }).catch((napaka) => {
        this.text = napaka.response.data.napaka;
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    OdstraniZapis(id) {
      this.indexBrisanja = id;
      this.text = 'Ali res želiš izbrisati zapis?';
      this.types = 'Vprašanje';
      this.ShowNoti = true;
    },
    DodajZapisGlave() {
      this.glava.push({zapis: ''});
    },
    BrisiZapis() {
      this.glava.splice(this.indexBrisanja, 1);
      this.ShowNoti = false;
      this.indexBrisanja = '';
    },
    PosodobiGlavo() {
      this.isSubmitting = true;
      var podatki = new FormData();
      if ($(this.$refs.datoteka)[0].files[0] !== undefined) {
        podatki.append('logotipLetalisca', $(this.$refs.datoteka)[0].files[0]);
      }
      podatki.append('zapisi', JSON.stringify(this.glava));
      podatki.append('icao', 5);
      axios.post('./api/nastavitve/splosno/izpiski/', podatki, {withCredentials: true}).then((response) => {
        if (response.data.datoteka !== null) {
          this.logotip = response.data.datoteka;
        }
        $(this.$refs.datoteka).val('');
        this.isSubmitting = false;
      }).catch((napaka) => {
        this.isSubmitting = false;
      });
    },
  }
}
</script>
<template>
  <!-- VNOS PODATKOV ZA IZPIS -->
  <div class="form-section">
    <div class="section-header">
      <div class="section-icon">
        <i class="fas fa-file-alt"></i>
      </div>
      <div class="section-title">
        <h3>Podatki za izpise</h3>
        <p>Podatki, ki bodo upoštevani pri vseh izpisih</p>
      </div>
    </div>
    <div class="section-content">
      <!-- LOGO -->
      <div class='form-grid'>
        <div class="form-group" v-show="logotip !== ''">
          <p class="label-time p-2">Trenutni logotip za izpise</p>
          <img :src="'./img/upload/' + logotip" width="200px"/>
        </div>
        <div class="form-group">
          <label class="label-time p-2" for="potnik-ime-{{index}}"> {{ logotip !== '' ? 'Izberite nov logotip za izpise' : 'Izberite logotip, ki bo prikazan na izpisih'}}</label>
          <input class="input border-0 rounded-4 p-2 fs-5" type="file" id="{{index}}" ref="datoteka" />
        </div>
      </div>
      <!-- GLAVA -->
      <div class="form-grid">
        <TransitionGroup name="fade" tag="glava">
          <div v-for="(zapis, index) in  glava" :key="index" class="form-group">
            <div :class="{ hidden: zapis.zapis.length > 0 }" class="label-time">Izpis {{index +1}} - <button class="btn btn-outline-danger rounded btn-sm" @click.prevent="OdstraniZapis(index)"><i  class="far fa-minus fa" ></i></button></div>
            <label :class="{ hidden: zapis.zapis.length > 0 }" class="label-time p-2" :for="'potnik-ime-' + index">Nastavitev glave dokumenta izpisov</label>
            <input class="input border-0 rounded-4 p-2 fs-5" type="text" :id="'potnik-ime-' + index" v-model="zapis.zapis" required />
          </div>
          <div key="dodaj-gumb" class="container p-2">
            <button class="btn btn-outline-success rounded" @click.prevent="DodajZapisGlave()">Dodaj zapis</button>
          </div>
        </TransitionGroup>
      </div>
      <hr />
      <!-- PREDOGLED -->
      <div class="form-group" v-show="logotip !== ''">
        <p class="label-time p-2">Predogled izgleda glave dokumenta</p>
        <img :src="'./img/upload/' + logotip" width="200px"/>
        <p class='"label-time p2 text-white' v-for="zapis in glava">
          {{zapis.zapis}}
        </p>
      </div>
    </div>
    <!-- Form Actions -->
    <div class="form-actions">
      <div class="action-buttons">
        <button type="button"
                class="btn btn-primary"
                @click.prevent="PosodobiGlavo()"
                :disabled="isSubmitting">
          <i class="fas fa-sync-alt" v-if="!isSubmitting"></i>
          <i class="fas fa-sync-alt fa-spin" v-if="isSubmitting"></i>
          <span v-if="isSubmitting">Posodabljam</span>
          <span v-else>Posodobi vnos</span>
        </button>
      </div>
    </div>
  </div>
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @da="BrisiZapis()" @ne="ShowNoti = false" @closeNotification="ShowNoti = false" />
  </Transition>
</template>